import React from 'react'

export const TemplateStore = () => (
    <span> Estaciones híbridas < br / > (Sismólogica + Acelerográfica) </span>
)
